/**
 * Cookie debugger to see what's being stored
 */
export function debugCookies() {
  console.log('🍪 === COOKIE DEBUG ===');
  
  // Get all cookies
  const allCookies = document.cookie.split(';').reduce((acc, cookie) => {
    const [name, value] = cookie.trim().split('=');
    if (name) {
      acc[name] = decodeURIComponent(value || '');
    }
    return acc;
  }, {} as Record<string, string>);
  
  console.log('All cookies:', allCookies);
  
  // Check specific auth-related cookies
  const authCookies = Object.keys(allCookies).filter(key => 
    key.startsWith('sb-') || 
    key === 'isLoggedIn' || 
    key.startsWith('role_') ||
    key === 'language'
  );
  
  console.log('Auth-related cookies:', authCookies);
  
  // Check localStorage for comparison
  console.log('\n📦 === LOCALSTORAGE DEBUG ===');
  const authLocalStorage = [];
  for (let i = 0; i < localStorage.length; i++) {
    const key = localStorage.key(i);
    if (key && (
      key.startsWith('sb-') || 
      key === 'isLoggedIn' || 
      key.startsWith('user-role-') ||
      key === 'language'
    )) {
      authLocalStorage.push({
        key,
        value: localStorage.getItem(key)
      });
    }
  }
  
  console.log('Auth-related localStorage:', authLocalStorage);
  
  // Check if migration is needed
  const needsMigration = authLocalStorage.length > 0 && authCookies.length === 0;
  if (needsMigration) {
    console.log('⚠️ Migration needed! Data is in localStorage but not in cookies.');
  } else if (authCookies.length > 0) {
    console.log('✅ Cookies are being used for auth data.');
  }
  
  return {
    cookies: allCookies,
    authCookies,
    authLocalStorage,
    needsMigration
  };
}

// Auto-run on page load
if (typeof window !== 'undefined') {
  window.addEventListener('load', () => {
    setTimeout(debugCookies, 1000); // Run after 1 second to let auth initialize
  });
  
  // Export to window for manual debugging
  (window as any).debugCookies = debugCookies;
}